import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ReportService } from 'src/app/reports/services/report.service';
import * as moment from 'moment';
import { ApiService } from 'src/app/common/services/api.service';
import { apiEndPoints } from 'src/app/common/constants/api-endpointsconstant';

@Injectable({
  providedIn: 'root'
})
export class ReportProjectDetailsService {

  constructor(
    private apiService: ApiService,
    private reportService: ReportService
  ) { }

  projDetailLandParcel: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }
  projDetailHouses: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }
  projDetailOthers: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }
    projDetailLandPrices: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }
    projDetailPropertyPrices: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }
    projDetailUnitPrices: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  projectDetailOverview(queryParams: any, uid: string) {
    if (queryParams?.year) queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    let url: string;
    if (queryParams.year == null) {
      queryParams['year'] = new Date().getFullYear();
    }
    url = `${environment.miUrl}${apiEndPoints.projectDetailsOverview}?year=${queryParams['year']}&project_uid=${uid}`;
    return this.apiService.get(url);
  }

  getLandParcel(payload: any, projectUid: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailLandParcel.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.projectDetailsLandParcel}${changeParams}&limit=${payload?.pageSize}&offset=${offset}&project_uid=${projectUid}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiService.get(url, false);
  }
  getPropertyHouses(payload: any, projectUid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailHouses.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.projectDetailsPropertyHouses}${changeParams}&limit=${payload?.pageSize}&offset=${offset}&project_uid=${projectUid}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiService.get(url, false);
  }
  getPropertyOthers(payload: any, projectUid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailOthers.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.projectDetailsPropertyOthers}${changeParams}&limit=${payload?.pageSize}&offset=${offset}&project_uid=${projectUid}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiService.get(url, false);
  }
   getResidentialRental(payload: any, projectUid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailOthers.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
   let url: string = `${environment.miUrl}${apiEndPoints.ProjectDetailsResidentialRental}${changeParams}&project_uid=${projectUid}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    return this.apiService.get(url, false);
  }
     getRetailRental(payload: any, projectUid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailOthers.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
   let url: string = `${environment.miUrl}${apiEndPoints.ProjectDetailsRetailRental}${changeParams}&project_uid=${projectUid}`;

    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    return this.apiService.get(url, false);
  }
     getOfficeRental(payload: any, projectUid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailOthers.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
   let url: string = `${environment.miUrl}${apiEndPoints.ProjectDetailsOfficeRental}${changeParams}&project_uid=${projectUid}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    return this.apiService.get(url, false);
  }
    getWarehouseRental(payload: any, projectUid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailOthers.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let url: string = `${environment.miUrl}${apiEndPoints.ProjectDetailsWarehouseRental}${changeParams}&project_uid=${projectUid}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    return this.apiService.get(url, false);
  }

    getProjectLandPrices(payload: any, projectUid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailLandPrices.year || this.reportService.yearMaxValue(queryParams.year);
    }
    let offset = payload.pageNumber || 0
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
      let url: string = `${environment.miUrl}${apiEndPoints.projectLandPricesDetails}${changeParams}&limit=${payload?.pageSize}&offset=${offset}&project_uid=${projectUid}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
      if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiService.get(url, false);
  }

    getProjectLandPricesAnalysis(projectUid:string='', filter:any=null) {
      let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    if(filter) {
      queryParams['zoning_default']=filter;
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.projectDetailsLandPriceAnalysisReport}${changeParams}&project_uid=${projectUid}`;
    return this.apiService.get(url);
  }

  getProjectPropertyPricesAnalysis(projectUid:string='',  filter:any=null) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
      if(filter) {
      queryParams['zoning_default']=filter;
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.projectDetailsHousePriceAnalysisReport}${changeParams}&project_uid=${projectUid}`;
    return this.apiService.get(url);
  }
   getProjectApartmentPriceAnalysis(projectUid:string='', filter:any=null) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
       if(filter) {
      queryParams['unit_type']=filter;
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.projectDetailsApartmentPriceAnalysisReport}${changeParams}&project_uid=${projectUid}`;
    return this.apiService.get(url);
  }
   getProjectResidentialBuildingPriceAnalysis(projectUid:string='', filter:any=null) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
      if(filter) {
      queryParams['zoning_default']=filter;
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.projectDetailsResidentialBuildingPriceAnalysisReport}${changeParams}&project_uid=${projectUid}`;
    return this.apiService.get(url);
  }

    getPropertyPrice(payload: any, projectUid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailPropertyPrices.year || this.reportService.yearMaxValue(queryParams.year);
    }
    let offset = payload.pageNumber || 0
    const changeParams = this.reportService.setfilterQueryParams(queryParams);

    let url: string = `${environment.miUrl}${apiEndPoints.projectPropertyPriceDetails}${changeParams}&limit=${payload?.pageSize}&offset=${offset}&project_uid=${projectUid}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
      if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiService.get(url, false);
  }

    getProjectUnitPrice(payload: any, projectUid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projDetailUnitPrices.year || this.reportService.yearMaxValue(queryParams.year);
    }
    let offset = payload.pageNumber || 0
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let url: string = `${environment.miUrl}${apiEndPoints.projectUnitPriceDetails}${changeParams}&project_uid=${projectUid}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
      if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiService.get(url, false);
  }

  // getresidential chart data api
   getResidentialRentalAnalysis(projectUid:string='', filter:any=null) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
       if(filter) {
      queryParams['unit_type']=filter;
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.ProjectDetailsResidentialAnalysis}${changeParams}&project_uid=${projectUid}`;
    return this.apiService.get(url);
  }

    getRetailRentalAnalysis(projectUid:string='',filter:any=null ) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
        if(filter) {
      queryParams['unit_size']=filter;
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.ProjectDetailsretailAnalysis}${changeParams}&project_uid=${projectUid}`;
    return this.apiService.get(url);
  }
  getOfficeRentalAnalysis(projectUid:string='', filter:any=null) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
     if(filter) {
      queryParams['unit_size']=filter;
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.ProjectDetailsOfficeanAlysis}${changeParams}&project_uid=${projectUid}`;
    return this.apiService.get(url);
  }
  downloadProjectDetail(type: string, user_id: number, projectUid:string=''){
    let url: string = `${environment.miUrl}${apiEndPoints.reportDownload}${this.reportService.filterQueryParams}&type=${type}&user_id=${user_id}&project_uid=${projectUid}`;
    return this.apiService.get(url);
  }
  downloadExcelUrl(){
    return `${environment.miUrl}${apiEndPoints.downloadExcel}`;
  }
}
